module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/usps-6da9d824cdb6a915510ad362f87bdc0a.svg";